import { Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import CreateClass from "features/clients/details/classes/createClass";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { selectConfigration } from "redux/slices/configrationSlice";
import { selectUser } from "redux/slices/userSlice";
import K from "utilities/constants";
import AgGridUtility from "../../../../utilities/agGridUtility";
import { getColumns } from "./clientClassesContainer/columns";
import { ClientSideDataGrid } from "../../../../common/components/clientSideDataGrid/clientSideDataGrid";

export default function ClassTable({
  rowData,
  onRowClicked,
  getClientClassList,
  doesExternalFilterPass,
  isExternalFilterPresent,
  search,
}) {
  const [form] = useForm();
  const { id } = useParams();
  const userSlice = useSelector(selectUser);
  const userDetails = useSelector(selectUser).details;
  const [modalState, setModalState] = useState({
    editData: null,
    isCreateClassModalVisible: false,
    isDeleteClassModalVisible: false,
    deleteResponse: null,
    isUploadModalVisible: false,
    isLoadingClassModal: false,
    isLoadingUploadModal: false,
  });
  const lookupTables = useSelector(selectConfigration).lookup;

  const editRecord = async (recordId) => {
    setModalState((prev) => {
      return {
        ...prev,
        isCreateClassModalVisible: true,
        editJobId: recordId,
      };
    });
  };

  const columns = useMemo(
    () => getColumns(userSlice.roles, editRecord),
    [userSlice.roles],
  );

  const cancelHandler = () => {
    form.resetFields();
    setModalState((prev) => {
      return { ...prev, isCreateClassModalVisible: false };
    });
  };

  const afterModalClose = () => {
    form.resetFields();
  };

  const onCellClicked = (params) => {
    if (params.colDef.field !== "actions") {
      onRowClicked(params);
    } else {
      setModalState((prev) => {
        return {
          ...prev,
          editData: rowData.find((item) => item.id === params.data.id),
          isCreateClassModalVisible: true,
        };
      });
    }
  };

  return (
    <>
      <ClientSideDataGrid
        configKey={K.AgGridTable.Keys.ClientClassVisibleColumn}
        defaultColumnConfig={columns}
        userId={userDetails.id}
        rowData={rowData}
        isExternalFilterPresent={isExternalFilterPresent}
        doesExternalFilterPass={doesExternalFilterPass}
        getContextMenuItems={() => AgGridUtility.menuItemsWithExport}
        onCellClicked={onCellClicked}
        quickFilterText={search}
        rowStyle={{ cursor: "pointer" }}
      />
      <Modal
        centered
        width={632}
        open={modalState.isCreateClassModalVisible}
        okText="Update"
        title="Edit Class"
        onOk={form.submit}
        okButtonProps={{ loading: modalState.isLoadingClassModal }}
        onCancel={cancelHandler}
        closeIcon={<i className="icon-closeable" />}
        className="s2-theme-style jobsList modal-overflow-auto"
        afterClose={afterModalClose}
      >
        <CreateClass
          form={form}
          clientId={id}
          editData={{ ...modalState.editData }}
          lookupTables={lookupTables}
          setModalState={setModalState}
          getClientClassList={getClientClassList}
        />
      </Modal>
    </>
  );
}
